import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, Input, OnInit } from '@angular/core';
import { regularExpresions } from 'src/app/shared/utils/regular-expresions';

@Component({
  selector: 'app-cambio-contrasenia',
  templateUrl: './cambio-contrasenia.component.html',
  styleUrls: ['./cambio-contrasenia.component.scss']
})
export class CambioContraseniaComponent implements OnInit {

  @Input() usuarioId?: string;
  @Input() usuario?: string;
  datosForm: FormGroup;
  seePass = false;
  seePassConfirm = false;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
  ) {
    this.datosForm = this.fb.group({
      contrasenia: [null, [Validators.required, Validators.pattern(regularExpresions.PassRobustas)]],
      contraseniaConfirmar: [null, Validators.required]
    }, { validators: this.CheckPassword });
  }

  ngOnInit(): void {
  }

  CheckPassword(group: FormGroup): any {
    const password = group.get('contrasenia')?.value;
    const confirmPassword = group.get('contraseniaConfirmar')?.value;
    return password === confirmPassword ? null : { notSame: true };
  }

  Aceptar(): void {
    this.activeModal.close({
      action: 'Aceptar',
      contrasenia: this.datosForm.get('contrasenia')?.value
    });
  }

  Cancelar(): void {
    this.activeModal.close({
      action: 'Cancelar',
      contrasenia: null
    });
  }

  GetContraseniaControl(): AbstractControl | null {
    return this.datosForm.get('contrasenia');
  }
}
